export const AppConstants = {
  LOCAL_STORAGE_KEY: 'cloud.access',
  CREDIT_UNION_API_URL: process.env.VUE_APP_CREDIT_UNION_BASE_URL,
};
